//import react section
import React from 'react'
import { withRouter } from 'react-router-dom'
/** Material UI import section */
import { withStyles } from '@material-ui/core/styles'
import {  Card, CardHeader, Chip, Typography } from '@material-ui/core'
import moment from 'moment'
// import { Translate } from 'react-localize-redux'
//import helper test

/** Resources import section */
const useStyle = (theme) => ({})

const HeaderComponent = (props) => {
	//object props section
	const { loadAlert, supplier } = props
	//bool props section
	const { supplierLogo } = props
	//string props section
	const { urlImageSupplier, yourlogohere } = props
	return (
		<Card style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
			<CardHeader
				title={'Folio :' + loadAlert.formattedFolio}
				avatar={
					<img
						src={supplierLogo ? urlImageSupplier : yourlogohere}
						alt='logoSupplier'
						style={{
							maxHeight: 80,
						}}
					/>
				}
				subheader={
					supplier && (
						<Typography component={'div'} style={{ color: 'gray' }}>
							{supplier.rfc}{' '}
							<Typography component={'div'} style={{ color: 'gray' }}>
								{supplier.full_address}
							</Typography>
						</Typography>
					)
				}
			/>
			<div style={{ display: 'flex', flexDirection: 'column', margin: '20px', alignItems: 'flex-end' }}>
				<Chip
					label={loadAlert.statusDescription}
					style={{ borderRadius: '5px', width: '70%', height: '25px' }}
					color='inherit'
				/>
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<Typography component={'div'} variant='subtitle2'>
						Fecha de creación:
					</Typography>
					<Typography component={'div'} variant='body2' style={{ color: 'gray' }}>
						{moment(loadAlert.creationDate).format('L LT')}
					</Typography>
				</div>
			</div>
		</Card>
	)
}

HeaderComponent.propTypes = {}

HeaderComponent.defaultProps = {}
export default withRouter(withStyles(useStyle, { withTheme: true })(HeaderComponent))
